export const DEL_ITEM = 'DEL_ITEM'
export const REP_LIST = 'REP_LIST'
export const CHANGE_PAGING = 'CHANGE_PAGING'
export const UPDATE_ITEM = 'UPDATE_ITEM'